import './Home.css'
import apiClient from "../../utils/api.js";

import React, {useEffect} from 'react';
import {Link, Navigate} from "react-router-dom";
import {toast} from "react-toastify";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout.js";
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout.js";
import "./LargeNumber.css"

function LargeNumber({number, label}: {number: number, label?: string}) {
    return <div className="large-number">
        <div className="number">{number}</div>
        {label && <span className="large-number-label">{label}</span>}
    </div>
}


function Home() {
    const [isLoading, setIsLoading] = React.useState(true)
    const [redirectTo, setRedirectTo] = React.useState(null)
    const [databases, setDatabases] = React.useState(null)
    const [users, setUsers] = React.useState(null)
    const [roles, setRoles] = React.useState(null)

    useEffect(()=>{
        apiClient.verifyJWTNotExpired().then((validJWT) => {
            if (!validJWT) {
                toast.warn("login expired")
                setRedirectTo("/login")
            }
        }).catch((reason) => {
            console.log(reason)
        })

        apiClient.listDatabases().then((databases) => {
            setDatabases(databases)
        }).catch((error) => {
            console.error("Failed to fetch databases:", error)
            toast.error("Failed to fetch databases")
        })

        apiClient.listSyntheticUsers().then((users) => {
            setUsers(users)
        }).catch((error) => {
            console.error("Failed to fetch users:", error)
            toast.error("Failed to fetch users")
        })

        apiClient.listRoles().then((roles) => {
            setRoles(roles)
        }).catch((error) => {
            console.error("Failed to fetch roles:", error)
            toast.error("Failed to fetch roles")
        })
    }, [])

    useEffect(() => {
        if (databases && users && roles) {
            setIsLoading(false)
        }
    }, [databases, users, roles])

    if (redirectTo) {
        return <Navigate to={redirectTo} />
    }

    if (isLoading) {
        return <LoadingLayout/>
    }

    const content = <>
        <div className="resource-counts">
            <div className="resource-column">
                <Link to="/databases">
                    <LargeNumber number={databases.length} label="Databases" />
                </Link>
                <div className="resource-list">
                    {databases.map((db) => (
                        <Link key={db.id} to={`/database/${db.id}`}>{db.name}</Link>
                    ))}
                </div>
            </div>
            <div className="resource-column">
                <Link to="/users">
                    <LargeNumber number={users.length} label="Users" />
                </Link>
                <div className="resource-list">
                    {users.map((user) => (
                        <Link key={user.id} to={`/user/${user.id}`}>{user.name}</Link>
                    ))}
                </div>
            </div>
            <div className="resource-column">
                <Link to="/roles">
                    <LargeNumber number={roles.length} label="Roles" />
                </Link>
                <div className="resource-list">
                    {roles.map((role) => (
                        <Link key={role.id} to={`/roles`}>{role.name}</Link>
                    ))}
                </div>
            </div>
        </div>
        {/*<div className="resources-lists">*/}

        {/*    <div className="resource-list">*/}
        {/*        <Link to="/users/1">User 1</Link>*/}
        {/*        <Link to="/users/2">User 2</Link>*/}
        {/*        <Link to="/users/3">User 3</Link>*/}
        {/*    </div>*/}
        {/*    <div className="resource-list">*/}
        {/*        <Link to="/users/1">Role 1</Link>*/}
        {/*        <Link to="/users/2">Role 2</Link>*/}
        {/*        <Link to="/users/3">Role 3</Link>*/}
        {/*    </div>*/}
        {/*</div>*/}
    </>

    return (
        <FullWidthLayout title="" mainContent={content} showBreadcrumbs={false} />
    )
}

export default Home
